/**
 * LifecycleBadge — бейдж этапа жизненного цикла проекта.
 * Отображается везде рядом с цветовым StatusBadge.
 *
 * pre_project  → серый  «Предпроект»
 * in_design    → синий  «В работе»
 * post_design  → зелёный «Завершён»
 */
import type { ProjectLifecycleStage } from '@/types'

const STAGE_CONFIG: Record<ProjectLifecycleStage, { label: string; cls: string }> = {
  pre_project: {
    label: 'Предпроект',
    cls:   'bg-gray-100 text-gray-600 border border-gray-200',
  },
  in_design: {
    label: 'В работе',
    cls:   'bg-blue-50 text-blue-700 border border-blue-200',
  },
  post_design: {
    label: 'Завершён',
    cls:   'bg-emerald-50 text-emerald-700 border border-emerald-200',
  },
}

export default function LifecycleBadge({ stage }: { stage: ProjectLifecycleStage }) {
  const cfg = STAGE_CONFIG[stage]
  return (
    <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${cfg.cls}`}>
      {cfg.label}
    </span>
  )
}
